/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCarveOutRequest
 */
export interface CreateCarveOutRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    lead_medication_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    medication_name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    dosage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    route?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    frequency?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCarveOutRequest
     */
    cost_per_day?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    j_code?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    ndc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    stop_date?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCarveOutRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the CreateCarveOutRequest interface.
 */
export function instanceOfCreateCarveOutRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "medication_name" in value;

    return isInstance;
}

export function CreateCarveOutRequestFromJSON(json: any): CreateCarveOutRequest {
    return CreateCarveOutRequestFromJSONTyped(json, false);
}

export function CreateCarveOutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCarveOutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_medication_id': !exists(json, 'lead_medication_id') ? undefined : json['lead_medication_id'],
        'medication_name': json['medication_name'],
        'dosage': !exists(json, 'dosage') ? undefined : json['dosage'],
        'route': !exists(json, 'route') ? undefined : json['route'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'cost_per_day': !exists(json, 'cost_per_day') ? undefined : json['cost_per_day'],
        'j_code': !exists(json, 'j_code') ? undefined : json['j_code'],
        'ndc': !exists(json, 'ndc') ? undefined : json['ndc'],
        'stop_date': !exists(json, 'stop_date') ? undefined : json['stop_date'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
    };
}

export function CreateCarveOutRequestToJSON(value?: CreateCarveOutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_medication_id': value.lead_medication_id,
        'medication_name': value.medication_name,
        'dosage': value.dosage,
        'route': value.route,
        'frequency': value.frequency,
        'cost_per_day': value.cost_per_day,
        'j_code': value.j_code,
        'ndc': value.ndc,
        'stop_date': value.stop_date,
        'notes': value.notes,
    };
}

